import { createSlice } from "@reduxjs/toolkit";
import { createTemplate, deleteTemplate, updateTemplate } from "../features/ownerActions";
import { getStoredOwner } from "../../utils/authStorage";

const storedOwner = getStoredOwner<any>();

const templateSlice = createSlice({
  name: "template",
  initialState: {
    templates: [] as any[],
    selectedTemplate: {
      ownerId: storedOwner?._id || "",
      templateType: "EMAIL",
      templateName: "Invitation",
      content: {
        subject: "",
        body: "",
      },
    },
    loading: false,
    error: "",
    success: false,
    newTemplateData: {
      ownerId: storedOwner?._id || "",
      templateType: "EMAIL",
      templateName: "Invitation",
      content: {
        subject: "",
        body: "",
      },
    },
  },
  reducers: {
    setTemplates: (state, action) => {
      state.templates = action.payload;
    },
    setNewTemplateData: (state, action) => {
      state.newTemplateData = action.payload;
    },
    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(createTemplate.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(createTemplate.rejected, (state, action) => {
        // @ts-ignore
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(createTemplate.fulfilled, (state, action) => {
        const saved = action.payload as any;
        const list: any[] = Array.isArray(state.templates) ? [...state.templates] : [];
        const idx = list.findIndex(
          (template: any) =>
            (saved?._id && template?._id === saved._id) ||
            (saved?.name && template?.name === saved.name)
        );
        if (idx >= 0) {
          list[idx] = saved;
        } else {
          list.unshift(saved);
        }
        state.templates = list;
        state.loading = false;
        state.success = true;
      });

    builder
      .addCase(updateTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTemplate.rejected, (state, action) => {
        // @ts-ignore
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(updateTemplate.fulfilled, (state, action) => {
        const saved = action.payload as any;
        const list: any[] = Array.isArray(state.templates) ? [...state.templates] : [];
        const idx = list.findIndex(
          (template: any) => saved?._id && String(template?._id) === String(saved._id)
        );
        if (idx >= 0) {
          list[idx] = saved;
        } else {
          list.unshift(saved);
        }
        state.templates = list;
        state.loading = false;
        state.success = true;
      });

    builder
      .addCase(deleteTemplate.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteTemplate.rejected, (state, action) => {
        // @ts-ignore
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(deleteTemplate.fulfilled, (state, action) => {
        state.templates = action.payload;
        state.loading = false;
        state.success = true;
      });
  },
});

export const { setTemplates, setNewTemplateData, setSelectedTemplate } =
  templateSlice.actions;
export default templateSlice.reducer;
